import { render, staticRenderFns } from "./instrumentAllocation.vue?vue&type=template&id=c6d91682&scoped=true&"
import script from "./instrumentAllocation.vue?vue&type=script&lang=js&"
export * from "./instrumentAllocation.vue?vue&type=script&lang=js&"
import style0 from "./instrumentAllocation.vue?vue&type=style&index=0&id=c6d91682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d91682",
  null
  
)

export default component.exports